import lscOwnerCreator from './creators/lscOwnerCreator';
import { pageNames } from '@atc/bonnet-paths';

export default lscOwnerCreator({
    namespace: pageNames.DEALER_DETAILS,
    store: 'lscOwner',
    storePrefix: `${pageNames.DEALER_DETAILS}.`,
    initialState: {},
});
